module.exports = __FOREMAN_VENDOR__PATTERNFLY_REACT_ICONS__;


//////////////////
// WEBPACK FOOTER
// external "__FOREMAN_VENDOR__PATTERNFLY_REACT_ICONS__"
// module id = @patternfly/react-icons
// module chunks = 0 1 2